import { get, intersection, take, replace } from "lodash";

let customerAddressGooglePlaceMap = {
  address1: ["post_box", "street_number", "route"],
  address2: [],
  country: ["country"],
  state: {
    JP: ["administrative_area_level_1"],
    global: [
      "administrative_area_level_1",
      "administrative_area_level_2",
      "administrative_area_level_3",
      "administrative_area_level_4",
      "administrative_area_level_5",
      "sublocality_level_1",
      "sublocality_level_2",
      "sublocality_level_3",
      "sublocality_level_4",
      "sublocality_level_5",
    ],
  },
  city: [
    "locality",
    "postal_town",
    "administrative_area_level_3",
    "administrative_area_level_4",
    "administrative_area_level_5",
    "sublocality_level_1",
    "sublocality_level_2",
    "sublocality_level_3",
    "sublocality_level_4",
    "sublocality_level_5",
    "administrative_area_level_1",
  ],
  zip: ["postal_code"],
};

const componentsOfInterest = [
  "post_box",
  "street_number",
  "route",
  "country",
  "administrative_area_level_1",
  "administrative_area_level_2",
  "administrative_area_level_3",
  "administrative_area_level_4",
  "administrative_area_level_5",
  "sublocality_level_1",
  "sublocality_level_2",
  "sublocality_level_3",
  "sublocality_level_4",
  "sublocality_level_5",
  "locality",
  "neighborhood",
  "postal_code",
  "postal_town",
];

const applyAddressLengthLimit = (address1) => {
  let lenLimit = 25;
  let address2 = "";

  if (address1.length > lenLimit) {
    // find index of address part where address is bigger than addresLenLimit characters
    let findIndex = function (parts) {
      let n = parts.length,
        i = 0,
        len = 0;
      while (i < n) {
        len = len + parts[i].length + 1;
        if (len > lenLimit) return i;
        i++;
      }
      return -1;
    };
    let parts = address1.split(/\s+/);
    let index = findIndex(parts);
    if (index >= 0) {
      address1 = take(parts, index).join(" ");
      address2 = parts.slice(index, parts.length).join("");
    }
  }
  return [address1, address2];
};
const reShapeGooglePlace = (place) => {
  let location = get(place, "address_components", []).reduce(function (acc, o) {
    let q = intersection(o.types, componentsOfInterest).shift();
    if (q) acc[q] = { long_name: o.long_name, short_name: o.short_name };
    return acc;
  }, {});
  location.formatted_address = get(place, "formatted_address", "");
  return location;
};

export const GooglePlaceConverter = {
  properties: customerAddressGooglePlaceMap,
  data: {},
  googlePlace: null,
  init(place) {
    this.googlePlace = reShapeGooglePlace(place);
    this.process();
    return this;
  },
  process() {
    this.setCountry();
    this.setState();
    this.setAddressLine();
    this.setCity();
    this.setZipCode();
  },
  toJSON() {
    return {
      country: this.data.country,
      countryCode: this.data.countryCode,
      state: this.data.state,
      stateCode: this.data.stateCode,
      stateLabel: this.data.stateLabel,
      city: this.data.city,
      address1: this.data.address1,
      address2: this.data.address2,
      zip: this.data.zip,
    };
  },
  setCountry() {
    this.data.countryCode = get(
      this.googlePlace,
      ["country", "short_name"],
      ""
    );
    this.data.country = get(this.googlePlace, ["country", "long_name"], "");
  },
  setState() {
    this.data.state = this.gPlace("state");
    this.data.stateLabel = this.gPlace("state", "long_name").split(",").shift();
    this.data.stateCode = this.gPlace("state", "short_name").split(",").shift();
  },
  setAddressLine() {
    let address = null;
    let address1Long = this.gPlace("address1");
    let address1Short = this.gPlace("address1", "short_name");
    let formattedAddr = get(this.googlePlace, "formatted_address", "")
      .split(",")
      .shift();
    address =
      address1Long.length < formattedAddr.length
        ? formattedAddr
        : // This logic is ported from AP. I'm not sure why address1Short is assigned if the current condition does not meet
          address1Short;
    let [address1, address2] = applyAddressLengthLimit(
      replace(address, ",", "")
    );
    let regexp = /\b(null|undefined)\b/g;
    this.data.address1 = replace(address1, regexp, "");
    this.data.address2 = replace(address2, regexp, "");
  },
  setCity() {
    this.data.city = this.gPlace("city").split(",").shift();
  },
  setZipCode() {
    let zip = this.gPlace("zip").trim();
    if (zip) zip = zip.split(",").shift();
    this.data.zip = zip;
  },
  /* this.read
   Based on this.properties  convert something from this:
   {
   "administrative_area_level_2": {
   "long_name": "Milton Keynes",
   "short_name": "Milton Keynes"
   },
   "administrative_area_level_1": {
   "long_name": "England",
   "short_name": "England"
   }
   }
   to this:
   'England, Milton Keynes'

*/ gPlace(property, nameType) {
    nameType = nameType || "long_name";
    let attributes = this.attributesFor(property);
    let reducer = (acc, googleCompName) => {
      let name = get(this.googlePlace, [googleCompName, nameType], null);
      if (name) acc = acc + (acc === "" ? "" : ", ") + name;
      return acc;
    };
    return attributes.reduce(reducer, "");
  },
  attributesFor(property) {
    let attributes = this.properties[property];
    if (property === "state") {
      attributes = attributes[this.data.countryCode] || attributes.global;
    }
    return attributes;
  },
};
